import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchDeleteDevice } from './dispatch-optimistic-patch';
import { DeleteDeviceQueryArg } from '../types/query-arg';

export const handleResultDeleteDevice: QueryHandler<
  DeleteDeviceQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchDeleteDevice(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
